var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandMint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 85,
    viewBox: "0 0 300 85",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 85,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4904 70.4546H14.2195V84.7454H54.4904V70.4546Z",
    fill: "#4BABA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4904 16H14.2195V30.2908H54.4904V16Z",
    fill: "#4BABA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7456 30.2197H54.4548V70.4906H68.7456V30.2197Z",
    fill: "#4BABA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2908 30.2197H0V70.4906H14.2908V30.2197Z",
    fill: "#4BABA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5873 69.2789V30.2197H115.538L124.59 54.5248L132.858 30.2197H155.987V69.2432H142.195V44.3323L134.355 69.2432H115.538L106.165 44.3323V69.2432H92.5873V69.2789Z",
    fill: "#4BABA2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180.435 30.2192V69.2428H166.358V30.2192H180.435Z",
    fill: "#4BABA2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.458 69.2784L204.562 40.376V69.2784H190.806V30.2192H217.178L229.865 56.7695V30.2192H243.55V69.2428H219.458V69.2784Z",
    fill: "#4BABA2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268.71 69.2784V40.0909H251.426V30.2192H300V40.0909H282.716V69.2784H268.71V69.2784Z",
    fill: "#4BABA2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandMint);
export default __webpack_public_path__ + "static/media/brand_mint.8ff4fff98712b8566af7ad303898f860.svg";
export { ForwardRef as ReactComponent };